module.exports = __webpack_public_path__ + "img/ic_female.bdf27382.svg";